import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router, 
    private authenticationService: AuthenticationService
  ) {}

  async canActivate(): Promise<boolean> {
    const isLoggedIn = await this.authenticationService.isLoggedIn();
    if (isLoggedIn) {
      return true;
    }
    
    this.router.navigate(['/']); // Redirigir a la página de login
    return false;
  }
}